import React from 'react';
import { useTranslation } from 'react-i18next'

import NearByButton from '../../../components/nearByNav/nearByButton'
import { topCategories } from '../../../store/global/tourCategories'
import { ITour, ITopToursCategory } from '../../../store';

interface INearByNavProps {
    tour: ITour,
    selectedTopCategory?: ITopToursCategory
}

export default ({ tour, selectedTopCategory } : INearByNavProps) => {
    const { t } = useTranslation()
    return (
        <div className="page-menu-content clearfix">
            <ul>
                <li className="near-by-label">
                    <label>{t('Near By')}:</label>
                </li>
                {topCategories.map((item) =>
                    <li key={item.name}>
                        <NearByButton
                            isActive={!!selectedTopCategory && item.name === selectedTopCategory.name}
                            topCategory={item}
                            tour={tour}
                        />
                    </li>
                )}
            </ul>
        </div>
    )
}